import React, { Component } from "react";
import { connect } from "react-redux";
import View from "components/quote/view/index";
import commonUtilities from "utilities/common";
import contentHelper from "utilities/contentHelper";

import "../../customize.scss";


export class CustomizeQuoteStepSeven extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { data, events, errors, customQuote, businessLogo, groupTypes } = this.props;
        const { currentStep } = data;

        if (currentStep !== 7) {
            return null;
        }

        if(customQuote?.status !== "SUCCESS") {
            return null;
        }
        let { languageCode } = customQuote?.data;

        let customizedQuote = contentHelper.finalizeQuoteResponse(customQuote, true);

        languageCode = commonUtilities.convertLanguage(languageCode);
        
        return (
            <View isIQMUser={false} quote={customizedQuote} forPDF={true} languageCode={languageCode} isPreview={true} isCustomQuote={true} businessLogo={businessLogo} groupTypes={groupTypes} />
        );
    }
}


const mapStateToProps = (state) => ({
    customQuote: state.customQuote,
    businessLogo: state.businessLogo,
    groupTypes: state.groupTypes
});

export default connect(mapStateToProps)(CustomizeQuoteStepSeven);
